import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './produtoForm';
import { setError, setSuccess } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaTabelaPreco, getListaImagens, getLinkAcesso } from './produtoActions';
import Select from '../common/form/select';

const columns = [

];

class Produto extends Component {

	state = {
		linhaSelecionada: null,
		modalImagem: null,
		imagemZoom: null,
		imagemZoomEscala: 1,
		sort: {
			field: 'razao_social',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);

		if (this.props.idTabelaPrecoPedido) {
			this.setState({
				id_tabela_preco: this.props.idTabelaPrecoPedido
			});
		}
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTabelaPreco();
		this.props.getLinkAcesso();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
			this.props.getListaTabelaPreco();
			this.props.getLinkAcesso();
		}, 60000);

    }

	componentWillUnmount() {		
		clearInterval(this.idIntervalAtualizacao);
		clearInterval(this.idIntervalAtualizacaoImagens);

		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setModalImagem(null);
		}
	};

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}

					{this.props.eventoPedido &&
					<button
						onClick={() => {
							this.props.eventoPedido(null);
						}}
						style={{
							position: 'fixed',
							right: 20,
							bottom: 20,
							width: 56,
							height: 56,
							borderRadius: '50%',
							border: 'none',
							background: '#ffc107',
							color: '#fff',
							fontSize: 24,
							fontWeight: 'bold',
							boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
							zIndex: 9999,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}
					>
						<i
							className='fa fa-times'
							style={{
								fontSize: 24
							}}
						/>
					</button>}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.descricao}
					${item.referencia}
				`.toUpperCase().includes(pesquisar)
				);
		}).filter(item => {
			return !(this.state.pesquisarCodigo || '').trim()
			|| (this.state.pesquisarCodigo.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.filter(pesquisarCodigo => 
					String(item.codigo || '').trim() == pesquisarCodigo.trim()
					|| parseInt(String(item.codigo || '').trim()) == pesquisarCodigo.trim()
				).length;
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const lista = this.filtrar();

		return (
			<div style={{ paddingBottom: 50 }}>

				{this.modalImagem()}

				<Row>
					<InputPesquisa
						cols='5 4 3 3'
						label='Código'
						autoFocus={!!this.props.eventoPedido}
						onChange={value => this.setState({
							pesquisarCodigo: value
						})}
					/>
					<InputPesquisa
						cols='7 8 5 5'
						label='Pesquisar'
						onChange={value => this.setState({
							pesquisar: value
						})}
					/>
					<Select
						label='Tabela de Preço'
						placeholder='Informe'
						options={this.props.listaTabelaPrecoSelect}
						cols='12 12 4 4'
						value={this.state.id_tabela_preco}
						onChange={value => {
							this.setState({
								id_tabela_preco: value
							});
						}} />
				</Row>

				<div>

					{lista.map((item, i) => {

						const tabelaPrecoItem = this.props.listaTabelaPrecoItemSelect.filter(tabela => 
							tabela.id_tabela == this.state.id_tabela_preco
							&& tabela.id_produto == item.id_produto
						)[0];

						const preco = tabelaPrecoItem ? tabelaPrecoItem.preco : 0;

						return (
							<div
								key={item.id_produto}
								style={{
									backgroundColor: '#fff',
									borderRadius: 16,
									marginBottom: 16,
									padding: 16,
									boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
									border: this.state.linhaSelecionada == item.id_produto
										? '2px solid #5b7fff'
										: '1px solid #e5e5e5'
								}}
								onClick={e => {
									e.stopPropagation();
									//Retorna o produto pra tela do pedido
									if (this.props.eventoPedido) {
										this.props.eventoPedido({
											...item,
											id_tabela_item: tabelaPrecoItem ? tabelaPrecoItem.id : null,
											preco: preco
										});
									}
								}}
							>
								{item.imagem &&
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										marginBottom: 16
									}}
									onClick={e => {
										e.stopPropagation();
										this.setModalImagem(item);
									}}
								>

									{item.imagem ? (
										<img
											src={String(item.imagem)}
											alt='Produto'
											style={{
												width: '100%',
												height: 140,
												objectFit: 'contain',
												borderRadius: 12,
												backgroundColor: '#ffffff',
												border: '1px solid #eee',
												padding: 8
											}}
										/>
									) : (
										<div
											style={{
												width: '100%',
												height: 140,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												backgroundColor: '#f5f5f5',
												borderRadius: 12,
												border: '1px solid #ddd'
											}}
										>
											<i
												className='fa fa-image'
												style={{
													fontSize: 48,
													color: '#999'
												}}
											/>
										</div>
									)}

								</div>}

								<div
									style={{
										fontSize: 14,
										fontWeight: 'bold',
										color: '#333',
										marginBottom: 4
									}}
								>
									{item.descricao}
								</div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										marginBottom: 8
									}}
								>
									<div>
										<div style={{ fontSize: 12, color: '#999' }}>
											Código
										</div>

										<div style={{ fontWeight: 600 }}>
											{item.codigo}
										</div>
									</div>

									<div style={{ textAlign: 'right' }}>
										<div style={{ fontSize: 12, color: '#999' }}>
											Referência
										</div>

										<div style={{ fontWeight: 600 }}>
											{item.referencia || '-'}
										</div>
									</div>
								</div>

								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between'
									}}
								>
									<div>
										<div style={{ fontSize: 12, color: '#999' }}>
											Preço
										</div>

										<div
											style={{
												color: '#2e7d32',
												fontWeight: 'bold',
												fontSize: 20
											}}
										>
											{tabelaPrecoItem ? `R$ ${FormatUtils.formatarValorTela(preco, 2)}`: 'Selecione a Tabela'}
										</div>
									</div>

									<div style={{ textAlign: 'right' }}>
										<div style={{ fontSize: 12, color: '#999' }}>
											Estoque
										</div>

										<div
											style={{
												fontWeight: 'bold',
												fontSize: 18,
												color: item.saldo_atual > 0
													? '#1976d2'
													: '#d32f2f'
											}}
										>
											{FormatUtils.formatarValorTela(item.saldo_atual, 0)} {item.unidade}
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	setModalImagem(registro) {
		this.setState({
			modalImagem: registro
		});

		if (registro) {
			this.props.getListaImagens(registro);
		}
	}

	modalImagem() {
		
		if (!this.state.modalImagem) {
			return;
		}

		const registro = this.state.modalImagem;

		return (
			<>
				<div className="modal-backdrop fade show"
					onClick={() => this.setModalImagem(null)} />
				<div class='modal fade show'
					onClick={() => this.setModalImagem(null)}
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'
						onClick={(e) => e.stopPropagation()}>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1B4D3E', color: '#fff' }}>
								<h4 class='modal-title' style={{ fontSize: 14 }}>{registro.codigo} - {registro.descricao}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setModalImagem(null)}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<Row>
									<Grid cols='12 12 12 12'>
										<div
											style={{
												backgroundColor: '#fff',
												borderRadius: 16,
												marginBottom: 16,
												padding: 16,
												boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
											}}
										>
											<div
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: 16,
													justifyContent: 'center',
													marginBottom: 16
												}}
											>

												{this.props.listaImagens.map((item, index) => {

													const imagem = item.imagem;

													if (!imagem) {
														return (
															<div
																key={item.id_produto}
																style={{
																	width: 220,
																	height: 220,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	backgroundColor: '#f5f5f5',
																	borderRadius: 12,
																	border: '1px solid #ddd'
																}}
															>
																<i
																	className='fa fa-image'
																	style={{
																		fontSize: 48,
																		color: '#999'
																	}}
																/>
															</div>
														);
													}

													return (
														<div
															key={index}
															style={{
																position: 'relative',
																borderRadius: 12,
																border: '1px solid #eee',
																backgroundColor: '#fff',
																padding: 8,
																width: 220
															}} >
															{/* BOTÃO WHATSAPP */}
															{/*<button
																onClick={async (e) => {

																	e.stopPropagation();

																	try {

																		const imagemEnviar = imagem.startsWith('data:')
																			? imagem
																			: `data:image/jpeg;base64,${imagem}`;

																		const img = new Image();

																		img.src = imagemEnviar;

																		img.onload = async () => {

																			const canvas = document.createElement('canvas');

																			canvas.width = img.width;
																			canvas.height = img.height;

																			const ctx = canvas.getContext('2d');

																			ctx.drawImage(img, 0, 0);

																			canvas.toBlob(async (blob) => {

																				try {

																					await navigator.clipboard.write([
																						new window.ClipboardItem({
																							'image/png': blob
																						})
																					]);

																					setSuccess('Imagem copiada');

																				} catch (err) {

																					console.log(err);

																					alert(err);
																				}

																			}, 'image/png');
																		};

																	} catch (ex) {

																		console.log(ex);

																		alert('Não foi possível copiar.');
																	}
																}}
																style={{
																	position: 'absolute',
																	top: 12,
																	right: 12,
																	width: 38,
																	height: 38,
																	borderRadius: '50%',
																	border: 'none',
																	backgroundColor: '#007bff',
																	color: '#fff',
																	zIndex: 2,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
																	cursor: 'pointer'
																}}
															>
																<i className='fas fa-clone' />
															</button>*/}

															{/* IMAGEM */}
															<div
																onClick={() => {
																	this.setState({
																		imagemZoom: imagem,
																		imagemZoomEscala: 1
																	});
																}}
																style={{
																	cursor: 'zoom-in'
																}}
															>

																<img
																	src={String(imagem)}
																	alt='Produto'
																	style={{
																		width: '100%',
																		height: 220,
																		objectFit: 'contain'
																	}}
																/>

															</div>
														</div>
													);
												})}

											</div>
										</div>
										{this.state.imagemZoom && (
										<div
											onClick={() => {
												this.setState({
													imagemZoom: null,
													zoomImagem: 1
												});
											}}
											style={{
												position: 'fixed',
												top: 0,
												left: 0,
												right: 0,
												bottom: 0,
												backgroundColor: 'rgba(0,0,0,0.94)',
												zIndex: 999999,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												padding: 20
											}}
										>

											{/* FECHAR */}
											<button
												onClick={(e) => {
													e.stopPropagation();

													this.setState({
														imagemZoom: null,
														zoomImagem: 1
													});
												}}
												style={{
													position: 'fixed',
													top: 8,
													right: 12,
													width: 46,
													height: 46,
													borderRadius: '50%',
													border: 'none',
													backgroundColor: '#ff5252',
													color: '#fff',
													fontSize: 22,
													fontWeight: 'bold',
													zIndex: 2,
													boxShadow: '0 2px 10px rgba(0,0,0,0.4)'
												}}
											>
												×
											</button>

											{/* IMAGEM */}
											<div
												onClick={(e) => e.stopPropagation()}
												style={{
													position: 'fixed',
													top: 0,
													left: 0,
													width: '100vw',
													height: '100vh',
													overflow: 'auto',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center'
												}}
											>

												<img
													src={String(this.state.imagemZoom)}
													alt='Zoom'
													style={{
														width: '100%',
														height: '100%',
														objectFit: 'contain',
														backgroundColor: '#fff',
														transform: `scale(${this.state.zoomImagem || 1})`,
														transition: 'transform 0.2s ease'
													}}
												/>

											</div>

											{/* CONTROLES ZOOM */}
											<div
												onClick={(e) => e.stopPropagation()}
												style={{
													position: 'fixed',
													bottom: 16,
													left: '50%',
													transform: 'translateX(-50%)',
													display: 'flex',
													alignItems: 'center',
													gap: 12,
													backgroundColor: '#d9d9d9',
													padding: '10px 18px',
													borderRadius: 50,
													backdropFilter: 'blur(10px)'
												}}
											>

												<button
													onClick={() => {
														this.setState({
															zoomImagem: Math.max(
																0.5,
																(this.state.zoomImagem || 1) - 0.2
															)
														});
													}}
													style={{
														width: 42,
														height: 42,
														borderRadius: '50%',
														border: 'none',
														backgroundColor: '#ffffff',
														fontSize: 16,
														fontWeight: 'bold',
														boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
													}}
												>
													<i className='fa fa-search-minus' />
												</button>

												<div
													style={{
														color: '#000',
														fontWeight: 'bold',
														fontSize: 16,
														minWidth: 60,
														textAlign: 'center'
													}}
												>
													{Math.round((this.state.zoomImagem || 1) * 100)}%
												</div>

												<button
													onClick={() => {
														this.setState({
															zoomImagem: Math.min(
																5,
																(this.state.zoomImagem || 1) + 0.2
															)
														});
													}}
													style={{
														width: 42,
														height: 42,
														borderRadius: '50%',
														border: 'none',
														backgroundColor: '#ffffff',
														fontSize: 16,
														fontWeight: 'bold',
														boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
													}}
												>
													<i className='fa fa-search-plus' />
												</button>

											</div>

										</div>

									)}
									</Grid>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.produto.modoTela,
	aguardando: state.produto.aguardando,
	lista: state.produto.lista.filter(item => item.liberado),
	listaTabelaPrecoSelect: state.produto.listaTabelaPrecoSelect,
	listaTabelaPrecoItemSelect: state.produto.listaTabelaPrecoItemSelect,
	listaImagens: state.produto.listaImagens
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaTabelaPreco, getListaImagens, getLinkAcesso
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Produto);
